if ($('.id-404').length) {
    $(".content-inner .notFoundText").after(`
        <div class="contactUs"><div class="left"><div class="text"></div></div><div class="right"></div></div>
      `
    );
    $(' .contactUs .left').prepend($('footer#footer .helpFooter .personLine').clone());
    $('.contactUs .right').append($('footer#footer .helpFooter .mobileCenter').clone().find('a').text(translation('vsechnyKontakty')));
    $(' .contactUs .left .text').append($('footer#footer .helpFooter .online').clone());
    //$('.cart-empty .contactUs .left').append($('footer#footer .helpFooter .online').clone());
    $(' .contactUs .left .text').append('<span class="js">' + translation('jsmeTu') + '</span>');
    $(' .contactUs .left .text').append('<span class="po">' + translation('poradit') + '</span>');
    $(" .contactUs .right").append("<ul></ul>");
    $(" .contactUs .right ul").append(
        $("footer#footer .contact-box span.tel").closest("li").clone(),
        $("footer#footer .contact-box span.mail").closest("li").clone(),
    );

    $(document).ready(function () {


        if (!$('.hpBannerTopCategories').length) {

            //    sessionStorage.removeItem('loadedCategories');
            //     sessionStorage.removeItem('loadedTopBrands');
            if (sessionStorage.loadedCategories) {
                $('.pageArticleDetail>div').append('<div class="hpBannerTopCategories">' + sessionStorage.loadedCategories + '</div>');
                if (sessionStorage.loadedTopBrands) {
                    $('.pageArticleDetail>div').append('<div class="topBrands">' + sessionStorage.loadedTopBrands + '</div>');
                }
                slickItems();
            } else {
                // Jinak načti AJAXem
                $.ajax({
                    type: "GET",
                    dataType: "html",
                    timeout: 10000,
                    cache: true,
                    url: "/",
                    success: function (e) {
                        var doc = shoptet.common.createDocumentFromString(e);

                        // Kategorie
                        var categoriesHtml = $(doc).find(".benefitBanner.position--benefitHomepage .hpBannerTopCategories").html();
                        if (categoriesHtml !== null) {
                            $('.pageArticleDetail>div').append('<div class="hpBannerTopCategories">' + categoriesHtml + '</div>');
                            sessionStorage.loadedCategories = categoriesHtml;
                        }

                        // Značky
                        var brandsHtml = $(doc).find(".benefitBanner.position--benefitHomepage .topBrands").html();
                        if (brandsHtml !== null) {
                            $('.pageArticleDetail>div').append('<div class="topBrands">' + brandsHtml + '</div>');
                            sessionStorage.loadedTopBrands = brandsHtml;
                        }

                        slickItems();
                    }
                });
            }
        } else {
            slickItems();
        }

        updateSupportStatus()
    });
}

